import { VehicleModel } from './../models/vehicle.model';
import { VehicleService } from './../models/vehicle.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel } from '../../shared/config';


@Component({
  selector: 'wego-vehiclefuturebooking-list',
  template: require('../views/vehiclafuturebooking-list.component.html'),
  providers: [VehicleService],
})
export class VehicleFutureBookingListComponent implements OnInit {
  DataListModel: DataListModel;
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  urlDefaultPage: string;
  futureBookingList: any;
  model: VehicleModel;
  sub: any;
  vehicleMasterHashId: string;
  urlBooking: string;
  urlVehicleList: string;

  private breadCrumbList: string;


  constructor(private vehicleService: VehicleService,
    private translate: TranslateService,
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private router: Router) {
  }

  ngOnInit() {
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["bookingReferenceID", "driver","translatedBookingStatus"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlVehicleList = this.authService.GetURL(ApplicationRouteURL.URL_VEHICLE_LIST);
    this.urlBooking = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING);
    this.model = new VehicleModel();
    this.breadCrumbList = this.translate.instant('LblVehFutureBookingList');
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.vehicleMasterHashId = params['vehicleHashId'] || '';
        if (this.vehicleMasterHashId != '') {
          this.GetFutureBookingList();
        }
      });
  }

  public GetFutureBookingList() {
    this.isLoading = true;
    this.vehicleService.GetVehicleFutureBookingList(this.vehicleMasterHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        this.futureBookingList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetFutureBookingList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetFutureBookingList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetFutureBookingList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetFutureBookingList();
  };

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle/components/vehiclefuturebooking-list.component.ts